import React from 'react';

// each group lists organisations, and each organisation lists its roles
// (or programmes / certificates), newest first
const groups = [
	{
		id: 'cv-experience',
		title: 'Experience',
		orgs: [
			{
				name: 'Hailer Oy',
				meta: ['B2B SaaS', 'Porvoo, Finland'],
				entries: [
					{
						title: 'Frontend Developer & UI/UX Designer',
						dates: 'Oct 2023 – Present',
						description:
							"The sole designer at Hailer and the team's go-to UI developer. I own the UX/UI of the web app, maintain the design system, lead accessibility (WCAG) work, and design and build UI in Angular, plus customer-specific apps in React together with clients.",
					},
					{
						title: 'Frontend Developer',
						dates: 'Dec 2022 – Oct 2023',
						description:
							'Built features and UI components in Angular, and advised the design team on accessibility and frontend feasibility. This laid the groundwork for my combined design and development role.',
					},
					{
						title: 'Frontend Developer Intern',
						dates: 'Sep 2022 – Nov 2022',
						description:
							'Implemented new designs for existing features in Angular, working closely with the designer and developers.',
					},
				],
			},
			{
				name: 'Travel Specialist Group Oy – Risteilykeskus, Saga Matkat',
				meta: ['Travel', 'Helsinki, Finland'],
				entries: [
					{
						title: 'Office Manager & Product Manager',
						dates: 'Sep 2012 – Aug 2021',
						description:
							"Managed operations, sales and customer projects in a regulated travel agency environment. Designed, priced and sold tailor-made group trips to the Baltics, and planned and delivered group travel products end to end: first Saga Matkat's Estonian spa holiday packages, then its themed group tours across Europe. Ran the office and its finances (accounts receivable and payable), and was the team's go-to person for travel legislation, taxation and the Winres ERP/CRM system, often solving complex cases by translating rules into practical solutions.",
					},
				],
			},
			{
				name: 'Lomarengas Oy',
				meta: ['Travel', 'Helsinki, Finland', 'Part-time'],
				entries: [
					{
						title: 'Accounts Assistant',
						dates: 'Dec 2020 – Jul 2021',
						description:
							'Handled accounts receivable and payable in a four-person finance team, working closely with customers and the sales team. Main tool: Visma Wintime.',
					},
				],
			},
		],
	},
	{
		id: 'cv-education',
		title: 'Education & certifications',
		orgs: [
			{
				name: 'Uxcel',
				meta: ['Certification'],
				entries: [
					{
						title: 'UX/UI Designer',
						dates: 'Apr 2025',
						description:
							"Uxcel's professional certification, confirming demonstrated, professional-level competency in UX and UI design. Earned through self-paced study.",
						link: {
							href: 'https://app.uxcel.com/certificates/Z84VHMR5TYQ1',
							label: 'View certificate',
						},
					},
				],
			},
			{
				name: 'Helsinki Business College Oy',
				meta: ['Information Technology', 'Helsinki, Finland'],
				entries: [
					{
						title: 'Full Stack Web Developer program',
						dates: 'Aug 2021 – Dec 2022',
						description:
							'A full-time, hands-on program for career changers, taught in English and focused on the core skills of a software developer: HTML and CSS, UI design and prototyping, JavaScript, TypeScript, React and Redux, Node and Express, data structures, and continuous integration with AWS. Included two software development team projects, one of them with PHZ Full Stack. Graduated with a grade of 5/5.',
					},
				],
			},
			{
				name: 'Haaga-Helia University of Applied Sciences',
				meta: ['Business', 'Helsinki, Finland'],
				entries: [
					{
						title: 'Bachelor of Business Administration',
						dates: 'Jan 2007 – Mar 2012',
						description:
							'Major in Marketing, minor in Business and Entrepreneurship, completed as evening studies. Thesis: a business plan for an online interior design shop.',
					},
				],
			},
		],
	},
];

const CV = () => {
	return (
		<div className="background" id="cv">
			<div className="section-wrapper">
				<h2>CV</h2>
				{groups.map((group) => (
					<section
						className="cv-group"
						key={group.id}
						aria-labelledby={group.id}
					>
						<h3 className="cv-group-title" id={group.id}>
							{group.title}
						</h3>
						<div className="cv-group-body">
							{group.orgs.map((org) => (
								<article className="cv-org" key={org.name}>
									<h4 className="cv-org-name">{org.name}</h4>
									{org.meta && (
										<ul className="project-tags">
											{org.meta.map((item) => (
												<li key={item}>{item}</li>
											))}
										</ul>
									)}
									<ol className="cv-entries">
										{org.entries.map((entry) => (
											<li className="cv-entry" key={entry.title}>
												<h5 className="cv-entry-title">{entry.title}</h5>
												<p className="cv-entry-dates">{entry.dates}</p>
												{entry.description && (
													<p className="cv-entry-description">
														{entry.description}
													</p>
												)}
												{entry.link && (
													<a
														className="project-link"
														href={entry.link.href}
														target="_blank"
														rel="noopener noreferrer"
													>
														{entry.link.label}
														<span className="visually-hidden">
															{' '}
															(opens in a new tab)
														</span>
													</a>
												)}
											</li>
										))}
									</ol>
								</article>
							))}
						</div>
					</section>
				))}
			</div>
		</div>
	);
};

export default CV;
